enum BeeswaxPacingBehavior {
  Ahead = 'ahead',
  Even = 'even',
}

export default BeeswaxPacingBehavior;
